import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3aba11f9&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "@/app/assets/styles/app.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=3aba11f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports